import React from 'react';
import { Delete, Check } from 'lucide-react';
import { Button } from './ui/button';

interface NumPadProps {
  onKeyPress: (key: string) => void;
  onDelete: () => void;
  onSubmit?: () => void;
  showSubmit?: boolean;
  disabled?: boolean;
}

export const NumPad: React.FC<NumPadProps> = ({
  onKeyPress,
  onDelete,
  onSubmit,
  showSubmit = false,
  disabled = false,
}) => {
  const keys = [
    ['1', '2', '3'],
    ['4', '5', '6'],
    ['7', '8', '9'],
    ['', '0', 'del'],
  ];

  const handleKeyClick = (key: string) => {
    if (disabled) return;

    if (key === 'del') {
      onDelete();
    } else if (key !== '') {
      onKeyPress(key);
    }
  };

  return (
    <div className="grid grid-cols-3 gap-2 max-w-xs mx-auto">
      {keys.flat().map((key, index) => {
        if (key === '') {
          if (showSubmit && onSubmit) {
            return (
              <Button
                key={index}
                type="button"
                onClick={onSubmit}
                disabled={disabled}
                className="h-10 text-base font-semibold bg-green-500 hover:bg-green-600 text-white"
              >
                <Check className="w-5 h-5" />
              </Button>
            );
          }
          return <div key={index} className="h-10" />;
        }

        if (key === 'del') {
          return (
            <Button
              key={index}
              type="button"
              variant="outline"
              onClick={() => handleKeyClick(key)}
              disabled={disabled}
              className="h-10 text-base font-semibold hover:bg-red-50 hover:border-red-300 hover:text-red-600"
            >
              <Delete className="w-5 h-5" />
            </Button>
          );
        }

        return (
          <Button
            key={index}
            type="button"
            variant="outline"
            onClick={() => handleKeyClick(key)}
            disabled={disabled}
            className="h-10 text-lg font-semibold hover:bg-macartur-primary hover:text-white hover:border-macartur-primary transition-colors"
          >
            {key}
          </Button>
        );
      })}
    </div>
  );
};
